module.exports = __webpack_public_path__ + "static/2026_kyleKnaggsResume-be3cc12cf5312b0ebf3ef9f382986089.pdf";